import { colors, fonts, fontSizes} from 'theme'
import css from 'styled-jsx/css'

const containerString = `
.form-container {
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 16rem;
  width: 100%;
  height: 38rem;
  background-color: ${colors.white};
  border: 1px solid ${colors.border};
  position: sticky;
  align-self: flex-start;
  top: 5.375rem;
}
@media screen and (max-width: 992px) {
  .form-container{
    border-radius: 0.5rem;
    background-color: ${colors.white};
    border: solid 1px ${colors.border};
    padding: 1.5rem 2rem;
    max-width: inherit;
    margin-top: 1.3rem;
    max-width: 52rem;
  }
}
`


export const container = css`
.form-container {
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 16rem;
  width: 100%;
  height: 38rem;
  background-color: ${colors.white};
  border: 1px solid ${colors.border};
  position: sticky;
  align-self: flex-start;
  top: 5.375rem;
}
@media screen and (max-width: 992px) {
  .form-container{
    border-radius: 0.5rem;
    background-color: ${colors.white};
    border: solid 1px ${colors.border};
    padding: 1.5rem 2rem;
    max-width: inherit;
    margin-top: 1.3rem;
    max-width: 52rem;
  }
}
`

export default css`
  .form-container {
    display: flex;
    flex-direction: column;
    height: auto;
    max-width: 16rem;
    width: 100%;
    height: 38rem;
    background-color: ${colors.white};
    border: 1px solid ${colors.border};
    position: sticky;
    align-self: flex-start;
    top: 5.375rem;
  }
  .error-message-form {
    color: ${colors.danger};
  }
  @media screen and (max-width: 992px) {
    .form-container{
      border-radius: 0.5rem;
      background-color: ${colors.white};
      border: solid 1px ${colors.border};
      padding: 1.5rem 2rem;
      max-width: inherit;
      margin-top: 1.3rem;
      max-width: 52rem;
    }
  }
  .input-container {
    padding: 1rem;
  }
  .terms {
    font: ${fonts.regular};
    font-size: 10px;
    text-align: center;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
    color: ${colors.text};
  }
  .terms-link {
    color: ${colors.primary};
  }
  .form-container .actions {
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 1rem;
  }
  .form-container :global(.submit) {
    margin: 10px 0;
  }
`

export const success = css`
.form-container {
  display: flex;
  flex-direction: column;
  height: auto;
  max-width: 16rem;
  width: 100%;
  height: auto;
  background-color: ${colors.white};
  border: 1px solid ${colors.border};
  position: sticky;
  align-self: flex-start;
  top: 5.375rem;
  align-items: center;
  padding: 1.75rem;
}
.success-img {
  max-width: 9rem;
  width: 100%;
}
h4 {
  color: ${colors.primary};
}
`

export const currentOcupationStatusMessage = css`
  .wrapper {
    padding: 1rem 1rem 0;
  }
  .title{
    margin: 0 0 0.5rem;
    font-size: 1.1rem;
  }
  .subtitle {
    margin: 0;
    font-size: 0.85rem;
  }
`
